export const logisticsRoutes = [
  {
    path:'/logistics/deliveryPlan',
    component:()=>import('@/views/modules/logistics/delivery-plan/delivery-plan'),
    meta:{name:'发货计划',keepAlive:true,permission:'shipPlan:view',modal:'物流'}
  },
  {
    path: '/logistics/fba-shipment',
    component: () => import('@/views/modules/logistics/fba-shipment/fba-shipment-copy'),
    meta: { name: 'FBA货件', keepAlive: true, permission: 'shipment:view',modal:'物流'}
  },
  {
    path: '/logistics/fba-shipment-add',
    name: "fba-shipment-add",
    component: () => import('@/views/modules/common/logistics/fba-shipment/modal/add/fba-shipment-add'),
    meta: { name: '创建货件', keepAlive: true, permission: 'shipment:view' }
  },
  {
    path: '/logistics/logistics-provider',
    component: () => import('@/views/modules/logistics/logistics-provider/logistics-provider'),
    meta: { name: '物流商资料', keepAlive: true, permission: 'logistics:view',modal:'物流'}
  },
  {
    path: '/logistics/head-logistics',
    component: () => import('@/views/modules/logistics/head-logistics/head-logistics'),
    meta: { name: '头程物流', keepAlive: true, permission: 'transport:view',modal:'物流'}
  },
  {
    path: '/logistics/shipment-bill',
    component: () => import('@/views/modules/logistics/shipment-bill/shipment-bill'),
    meta: { name: '发货单', keepAlive: true, permission: 'shipNote:view',modal:'物流'}
  },
];
